(function(document) {
  "use strict";

  var app = document.querySelector("#app");

  app.baseUrl = window.location.pathname;
  
  window.onbeforeunload = function() {
    var user = app.$.api.exposed.user;
    if (user && user.isLogged()) {
      user.logout();
    }
  };

  app.displayInstalledToast = function() {
    // Check to make sure caching is actually enabled—it won't be in the dev environment.
    if (!Polymer.dom(document).querySelector("platinum-sw-cache").disabled) {
      Polymer.dom(document)
        .querySelector("#caching-complete")
        .show();
    }
  };

  app.addEventListener("dom-change", function() {
    console.log("Our app is ready to rock!");
  });

  // See https://github.com/Polymer/polymer/issues/1381
  window.addEventListener("WebComponentsReady", function() {
    // imports are loaded and elements have been registered
  });

  app.canSwitchWorkstation = function(ticket) {
    return ticket.state == "called";
  };

  app.scrollPageToTop = function() {
    app.$.headerPanelMain.scrollToTop(true);
  };

  app.closeDrawer = function() {
    app.$.paperDrawerPanel.closeDrawer();
  };

  app.menuAction = function() {
    app.$.paperDrawerPanel.togglePanel();
  };
})(document);
